var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'dark-mode': _vm.isDarkMode },attrs:{"id":"app"},on:{"wheel":_vm.handleWheel}},[_c('Header',{on:{"toTop":_vm.GoTop,"toBottom":_vm.GoBottom}}),_vm._v(" "),_c('div',{attrs:{"id":"contentApp"}},[_c('router-view')],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('GoTop'),_vm._v(" "),(_vm.isDev)?_c('Agentation'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b7fae4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 